import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import { guideSections } from '../Contents/guideContent';
import ScoringSystemModal from './ScoringSystemModal';

const Guide: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthentication();
  const [scoringModalOpen, setScoringModalOpen] = React.useState(false);

  const handleNavigation = (link: string) => {
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      navigate(link);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {guideSections.map((section, index) => {
        const SectionIcon = section.sectionIcon;
        const Icon = section.icon;

        return (
          <Box key={index} sx={{ mb: 3 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
                pb: 0.8,
                backgroundImage:
                  'linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%)',
                backgroundPosition: 'bottom',
                backgroundSize: '100% 1px',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    color: '#cc0000',
                    display: 'flex',
                    alignItems: 'center',
                    '& .MuiSvgIcon-root': {
                      fontSize: 'clamp(1rem, 1.5vw, 1.5rem)',
                    },
                  }}
                >
                  <SectionIcon />
                </Box>
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: 'clamp(1rem, 1.5vw, 1.5rem)',
                    fontFamily: 'Bebas Neue',
                  }}
                >
                  {section.heading}
                </Typography>
              </Box>
              {Icon && (
                <IconButton
                  size="small"
                  onClick={
                    section.heading === 'Scoring System'
                      ? () => setScoringModalOpen(true)
                      : () => handleNavigation(section.link!)
                  }
                  sx={{
                    color: 'white',
                    '&:hover': {
                      color: '#ff0000',
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                    },
                    '& .MuiSvgIcon-root': {
                      fontSize: 'clamp(1rem, 1.5vw, 1.5rem)',
                    },
                  }}
                >
                  <Icon />
                </IconButton>
              )}
            </Box>
            <Typography
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: 'clamp(0.8rem, 1.0vw, 0.9rem)',
                lineHeight: 1.4,
                '& br': {
                  display: 'block',
                  content: '""',
                  marginTop: '0.5em',
                },
                pl: 1,
              }}
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          </Box>
        );
      })}

      <ScoringSystemModal
        open={scoringModalOpen}
        onClose={() => setScoringModalOpen(false)}
      />
    </Box>
  );
};

export default Guide;
